import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("cit_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

// Silent session renewal: one in-flight refresh shared by every request that hit a 401.
let refreshing = null;
export const refreshSession = () => {
  if (!refreshing) {
    refreshing = axios.post(`${API}/auth/refresh`, {}, { withCredentials: true })
      .then((r) => { localStorage.setItem("cit_token", r.data.token); return r.data.token; })
      .finally(() => { refreshing = null; });
  }
  return refreshing;
};

// Only the session-establishing endpoints skip the retry; /auth/me and /auth/step-up/* must renew like any other call.
const NO_RETRY = ["/auth/refresh", "/auth/logout", "/auth/request-otp", "/auth/verify-otp"];
api.interceptors.response.use((r) => r, async (err) => {
  const cfg = err.config || {};
  if (err.response?.status === 401 && !cfg._retried && !NO_RETRY.some((p) => String(cfg.url || "").startsWith(p))) {
    cfg._retried = true;
    try {
      const token = await refreshSession();
      cfg.headers = { ...(cfg.headers || {}), Authorization: `Bearer ${token}` };
      return api(cfg);
    } catch { /* session truly ended */ }
  }
  return Promise.reject(err);
});

export const authFileUrl = (fileId) => {
  const t = localStorage.getItem("cit_token");
  return `${API}/files/${fileId}?auth=${t}`;
};

export const apiError = (e, fallback = "Something went wrong") => {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg).filter(Boolean).join(" ") || fallback;
  return fallback;
};
